export enum Page {
  "Home" = "",
  "AboutMe" = "about-me",
  "Funerals" = "funerals",
  "Weddings" = "weddings",
  "Namings" = "namings",
  "Contact" = "contact",
}
